import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    console.log('Feed controller connected');
    this.setupIntersectionObserver();
  }

  setupIntersectionObserver() {
    // Create an intersection observer to detect which feed item is currently in view
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: '0px',
      threshold: 0.7, // Item is considered visible when 70% is in view
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Add a class to the currently visible feed item
          entry.target.classList.add('feed-item-active');

          // If it's a video, play it
          const video = entry.target.querySelector('video');
          if (video) {
            video.play().catch((e) => console.error('Error playing video:', e));
          }
        } else {
          // Remove the class from items that are not visible
          entry.target.classList.remove('feed-item-active');

          // If it's a video, pause it
          const video = entry.target.querySelector('video');
          if (video) {
            video.pause();
          }
        }
      });
    }, options);

    // Observe all feed items
    const feedItems = this.element.querySelectorAll('.snap-start');
    feedItems.forEach((item) => {
      this.observer.observe(item);
    });
  }

  disconnect() {
    // Clean up the observer when the controller disconnects
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
